var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Centered',[_c('H1',[_vm._v("404")]),_c('Detail',[_vm._v("Hmmm, maybe double-check that URL?")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }